import { AllAppealStateType } from './Types';

export const allAppealInitialState: AllAppealStateType = {
	loading: false,
	error: null,
	data: null,
};
